import { useCallback } from "react";
import { AssembleTypography } from "src/components/AssembleTypography";
import { StyledBlockButton } from "../StyledBlockButton/StyledBlockButton";

const HEADER_3 = "header-three";

export type H3BlockProps = {
  editorState: Draft.EditorState;
  onClick: (headline: string) => void;
};

export const H3Block = (props: H3BlockProps): JSX.Element => {
  const { editorState, onClick } = props;

  const startKey = editorState.getSelection().getStartKey();
  const blockType = editorState
    .getCurrentContent()
    .getBlockForKey(startKey)
    .getType();
  const active = blockType === HEADER_3;

  const onClickHeadline = useCallback(() => {
    onClick(HEADER_3);
  }, [onClick]);

  return (
    <StyledBlockButton active={active} onClick={onClickHeadline}>
      <AssembleTypography style={{ fontSize: "22px", fontWeight: "bold" }}>
        H3
      </AssembleTypography>
    </StyledBlockButton>
  );
};
